export default __webpack_public_path__ + "static/media/message_on.d7e75600.png";